<template>
  <div>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Assign Tests</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-progress-linear
      slot="progress"
      color="primary"
      height="4"
      indeterminate
      v-show="progressBar"
    ></v-progress-linear>

    <v-card class="elevation-1">
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 sm6 md6>
                <v-select
                  v-model="batchId"
                  :items="batches"
                  item-text="Name"
                  name="Batch"
                  label="Batch"
                  id="Batch"
                  required
                  v-on:change="changeStudentList"
                  item-value="Id"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-select
                  v-model="studentId"
                  :items="selectedStudents"
                  :item-text="title"
                  name="StudentName"
                  label="Student Name"
                  id="StudentName"
                  required
                  item-value="Id"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-select
                  v-model="questionPaper"
                  :items="tests"
                  item-text="title"
                  name="QuestionPaper"
                  label="Question Paper"
                  id="QuestionPaper"
                  required
                  item-value="id"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" outline @click="reset">Reset</v-btn>
        <v-btn color="primary" @click="save" :disabled="!valid">Go</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import dbStore from "../db/dbStore";
import { mapMutations, mapGetters } from "vuex";

export default {
  created() {
    if (!this.$store.getters.get_login) {
      this.$router.push({
        path: "/signin"
      });
    }
    this.getData();
  },
  data() {
    return {
      valid: false,
      studentId: "",
      batchId: "",
      questionPaper: [],
      questionPaperSet: [],
      questionPapersInSet: null,
      progressBar: false,
      studentProgressModel: {
        id: "",
        tests_taken: []
      },
      testsTakenModel: {
        id: "",
        taken_on: "",
        score: 0,
        passed: false
      },
      students: [],
      selectedStudents: [],
      tests: [],
      batches: []
    };
  },
  computed: {
    login_details: function() {
      return this.$store.getters.get_login_details;
    }
  },

  methods: {
    title: item => item.FirstName + " " + item.LastName,

    changeStudentList(id) {
      this.selectedStudents = this.students.filter(item => {
        return item.Batch == id;
      });
    },
    async getData() {
      this.progressBar = true;
      dbStore.setCollectionName("students");
      this.students = await dbStore.getItems();
      dbStore.setCollectionName("tests");
      this.tests = await dbStore.getItems();
      dbStore.setCollectionName("batches");
      this.batches = await dbStore.getItems();
      
      var filter = { Field: "Status", Operator: "!=", Value: "Closed" };
      this.batches = this.filterItems(this.batches, filter);
      this.batches = await this.getBatchesForCurrentCenter(this.batches)

      this.progressBar = false;
    },

    async getBatchesForCurrentCenter(batches) {
      var temp = []
      var centerId = this.login_details.centerId
      batches.forEach(batch => {
        if(centerId == 0 || batch.CenterId === centerId) {
          temp.push(batch)
        }
      });
      return temp
    },

    filterItems(items, filter) {
      var temp = [];
      items.forEach(element => {
        if (element[filter.Field]) {
          var statement =
            '"' +
            element[filter.Field] +
            '"' +
            filter.Operator +
            '"' +
            filter.Value +
            '"';
          if (eval(statement)) {
            temp.push(element);
          }
        } else {
          temp.push(element);
        }
      });
      return temp;
    },

    reset() {
      this.$refs.form.resetValidation();
      this.studentId = "";
      this.questionPaper = "";
      this.selectedStudents = [];
      this.batchId = "";
    },

    save() {
      if (this.$refs.form.validate()) {
        this.studentProgressModel.id = this.studentId;
        this.testsTakenModel.id = this.questionPaper;
        this.testsTakenModel.taken_on = Date.now();
        this.studentProgressModel.tests_taken.push(this.testsTakenModel);
        this.updateStudentTest();
      }
    },

    getTestFromId(id) {
      var test;
      this.tests.forEach(element => {
        if (element.id == id) test = element;
      });
      return test;
    },

    async updateStudentTest() {
      let response;
      try {
        dbStore.setCollectionName("studentprogress");
        response = await dbStore.setItem(
          this.studentProgressModel,
          this.studentId
        );

        if (response.isStateChanged) {
          var test = this.getTestFromId(this.questionPaper);
          var set = test.set;
          var lang = test.lang;

          this.$router.push({
            name: "test",
            params: { set: set, lang: lang, id: this.studentId }
          });
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error getting data : " + err);
      }
    },
    
    ...mapMutations([
      "_login_details"
    ])
  }
};
</script>

<style scoped></style>
